import React, { useRef, useState } from 'react';
import { Alert, useToast, Spinner, Stack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const CustomLoadingToast = () => {
  const { t } = useTranslation();

  return (
    <Alert
      variant="solid"
      status="info"
      borderRadius="md"
      className="awt-loading-toast"
    >
      <Stack direction="row" align="center" spacing={4}>
        <Spinner color="white" size="md" />
        <span>{t('titles.updating_subscription')}</span>
      </Stack>
    </Alert>
  );
};

export const useLoadingToast = () => {
  const toast = useToast();
  const loadingToastRef = useRef();

  const [fetchingApiCalls, setFetchingApiCalls] = useState(0);

  const incrementApiCalls = () => setFetchingApiCalls((prev) => prev + 1);
  const decreaseApiCalls = () => setFetchingApiCalls((prev) => prev - 1);

  const closeToast = () => {
    if (loadingToastRef.current) {
      toast.close(loadingToastRef.current);
    }
  };

  const addToast = ({ toastRef, ...toastOptions }) => {
    if (!toastRef) {
      if (!toast.isActive(toastOptions.id)) {
        toast({ ...toastOptions });
      }
    } else {
      toastRef.current = toast({
        ...toastOptions,
      });
    }
  };

  const addLoadingToast = () => {
    addToast({
      toastRef: loadingToastRef,
      id: 'loading',
      status: 'info',
      isClosable: false,
      duration: null,
      position: 'top',
      render: CustomLoadingToast,
    });
    incrementApiCalls();
  };

  const removeLoadingToast = () => {
    decreaseApiCalls();
    if (fetchingApiCalls === 0) {
      closeToast();
    }
  };

  return { addLoadingToast, removeLoadingToast };
};
